import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-inline',
  template: `
    <div class="inline-loading" role="status" aria-live="polite">
      <div class="spinner" [style.width]="size" [style.height]="size" aria-hidden="true"></div>
    </div>
  `,
  styles: [`
    .inline-loading {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 6px 8px;
      box-sizing: border-box;
      background: transparent;
      color: var(--loading-color, #333);
    }

    .spinner {
      border-radius: 50%;
      border: 3px solid rgba(0,0,0,0.08);
      border-top-color: var(--spinner-color, #7855ED);
      animation: inline-spin 1s linear infinite;
      flex: 0 0 auto;
    }

    .msg {
      font-size: 0.9rem;
      line-height: 1;
      white-space: nowrap;
    }

    @keyframes inline-spin {
      to { transform: rotate(360deg); }
    }

    /* Make sure inline loader doesn't inherit any global fixed/overlay styles */
    :host { display: inline-block; }
  `]
})
export class InlineLoadingComponent {
  @Input() size: string = '1rem';
}
